import { EventEmitter, Injectable, Type } from "@angular/core";
import { ITaxManagementTaxRateResult } from "rl-common/services/accounting-processes/models/i-tax-management-tax-rate";
import { ModalAdapter } from "rl-common/services/modal-adapter/modal-adapter";

export interface IApTaxRateModalComponent {
	apTaxTypId: string;
	divId: number;
	existingRates: ITaxManagementTaxRateResult[];
	taxRate: ITaxManagementTaxRateResult | null;
	onComplete: EventEmitter<ITaxManagementTaxRateResult>;
}

@Injectable({ providedIn: "root" })
export class ApTaxRateModalAdapter extends ModalAdapter<IApTaxRateModalComponent> {
	// eslint-disable-next-line @angular-eslint/prefer-inject -- modal component type is configuration supplied by the provider factory.
	constructor(type: Type<IApTaxRateModalComponent>) {
		super(type);
	}
}
